import { useState, useEffect } from 'react'
import Background from './components/bg/Background'
import Content from './widgets/content/Content'
import Load from './widgets/load/Load'
import './App.css';

function App() {

  const [user, setUser] = useState([])

  async function getData(username){
    try{
      const response = await fetch(`https://xatme.com/api/me/${username}`)
      const result = await response.json()
      setUser(result)
    }
    catch(err){
      console.log('Erro: ', err)
    }
  }

  useEffect(() => {
    getData('tests')
  }, [])

  return (
    <div className="App">
      <Load load={user} />
      <Content data={user} />
      <Background />
    </div>
  );
}

export default App;
